import { defineComponent as _defineComponent } from 'vue'
import { ref, onUnmounted } from 'vue';

import { useRouter } from '@router';
import { delay } from '@tools/delay';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteLoadProgressBar',
  setup(__props) {

const router = useRouter();

const visible = ref(false);
const progress = ref(0);
const displayProgress = ref(0);

// On before each route.
onUnmounted(
  router.beforeEach((_to, _from, next) => {
    // ...
    void initializeDisplay();

    next();
  }),
);

// On after each route.
onUnmounted(
  router.afterEach(() => {
    progress.value = 100;
  }),
);

/**
 * ...
 */
async function initializeDisplay() {
  progress.value = 50;
  displayProgress.value = 0;

  if (visible.value) return;

  // ...
  visible.value = true;

  // ...
  await updateDisplay();

  // ...
  visible.value = false;
}

/**
 * ...
 */
async function updateDisplay() {
  if (displayProgress.value >= 100) return;

  if (displayProgress.value < progress.value) {
    displayProgress.value = Math.min(progress.value, displayProgress.value + 2);
  }

  // ...
  await delay();

  // ...
  await updateDisplay();
}

return { __sfc: true,router, visible, progress, displayProgress, initializeDisplay, updateDisplay }
}

})